const BASE = (process.env.REACT_APP_API_BASE || '').replace(/\/$/, '');
export async function transferRequest(path, body, text = false) {
  const token = localStorage.getItem('token') || localStorage.getItem('authToken') || localStorage.getItem('jwt') || sessionStorage.getItem('token') || sessionStorage.getItem('authToken') || '';
  const response = await fetch(`${BASE}/api/candidate-transfer${path}`, {
    method: body === undefined ? 'GET' : 'POST', credentials: 'include',
    headers: { ...(token ? { Authorization: `Bearer ${token.replace(/^Bearer\s+/i, '')}` } : {}), ...(body === undefined ? {} : { 'Content-Type': 'application/json' }) },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  if (!response.ok) { const error = await response.json().catch(() => ({})); throw new Error(error.error || 'Candidate transfer failed.'); }
  return text ? response.text() : response.json();
}
export function downloadCsv(value, name) {
  const url = URL.createObjectURL(new Blob([value], { type: 'text/csv;charset=utf-8' }));
  const link = document.createElement('a'); link.href = url; link.download = name;
  document.body.appendChild(link); link.click(); link.remove(); window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
export function templateCsv(fields) {
  return '\uFEFF' + fields.map(f => `"${f.label.replace(/"/g, '""')}"`).join(',') + '\r\n';
}
